import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { Select } from 'antd'
import { useProductsByShops } from '../ProductsByShopTooltip/useProductsByShop'

interface TaxProductsContainerProps {
  selectedShop: string | null
  setSelectedShop: (shop: string) => void
}

const TaxProductsContainer: React.FC<TaxProductsContainerProps> = ({ selectedShop, setSelectedShop }) => {
  const productsByShops = useProductsByShops()

  const productBoxStyles = {
    width: '100%',
    overflow: 'auto',
    maxHeight: '100px',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
    '&::-webkit-scrollbar-button': {
      display: 'none',
    },
  }

  return (
    <Box sx={productBoxStyles}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <Select
          value={selectedShop || productsByShops?.[0]?.shopName || ''}
          onChange={value => setSelectedShop(value)}
          style={{ width: '100%', fontFamily: 'Source Sans Pro' }}
          options={
            productsByShops?.map(shop => ({
              value: shop.shopName,
              label: shop.shopName,
            })) || []
          }
        />
      </Box>

      {selectedShop &&
        productsByShops
          ?.find(shop => shop.shopName === selectedShop)
          ?.products?.map((product, index) => (
            <Box
              key={`product_${index}`}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                minHeight: '32px',
                alignItems: 'center',
                fontFamily: 'Source Sans Pro',
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '24px',
                color: '#1c2842',
                textAlign: 'left',
                textWrap: 'pretty',
                borderBottom: '1px solid #dadbdf',
                paddingBottom: '12px',
              }}
            >
              {product.productLink ? (
                <a
                  href={product.productLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    fontSize: '16px',
                    color: '#2257C5',
                    textDecoration: 'none',
                    fontFamily: 'Source Sans Pro',
                    fontWeight: '400',
                  }}
                >
                  {product.title || `Product ${index + 1}`}
                </a>
              ) : (
                <span>{product.title || `Product ${index + 1}`}</span>
              )}
            </Box>
          ))}
    </Box>
  )
}

export default TaxProductsContainer
